<template>
  <!-- <div>
  <Bubble>-->
  <!-- <vue-headful title="Mach Mit! - Dachaudenktweiter"/> -->
  <router-view></router-view>
  <!-- </Bubble>
  </div>-->
</template>

<script>
export default {
  metaInfo: {
    title: "Mach mit!"
  }
};
</script>
